import m from "mithril";

export const Icons = {
  hamburger: m.trust(`<svg class="w-6 h-6 fill-current text-gray-300 hover:text-gray-200 transition duration-150 ease-in-out" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <rect y="4" width="24" height="2" rx="1" />
  <rect y="11" width="24" height="2" rx="1" />
  <rect y="18" width="24" height="2" rx="1" />
  </svg>`),

}